<template>
    <div class="operateChartLine" id="myFreightChartLine" :style="{height:height, width: width}"></div>
</template>
<script>
// import { validatenull } from '@/tdcommon/validate'

export default {
  name: 'd2-container-echarts-operate-line',
  data () {
    return {
      xAxisData: [],
      averageAmount: []
    }
  },
  props: {
    height: {
      type: String,
      default: () => ''
    },
    width: {
      type: String,
      default: () => ''
    },
    lineData: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
  },
  methods: {
    initChart (title, xAxisData, averageAmount) {
      // 引入基本模板
      var echarts = require('echarts/lib/echarts')
      // 引入折线图组件
      require('echarts/lib/chart/line')
      // 引入提示框和title组件
      require('echarts/lib/component/tooltip')
      require('echarts/lib/component/title')

      // 清空上一次值
      this.xAxisData = []
      this.averageAmount = []
      // 赋值
      this.xAxisData = xAxisData
      this.averageAmount = averageAmount

      let myChart = echarts.init(document.getElementById('myFreightChartLine'))
      var colors = ['#55A8FD', 'rgba(50, 197, 233, 1)', 'rgba(159, 230, 184, 1)']
      var options = {
        color: colors,
        title: { text: title },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: true },
            // magicType: { show: true, type: ['line', 'bar'] },
            // restore: {show: true},
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: [],
          selected: {}
        },
        grid: {
          left: '1%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xAxisData,
          axisLine: {
            lineStyle: {
              color: '#969696'
            }
          },
          axisLabel: {
            // formatter: function (value) {
            //   return value.split('').join('\n')
            // }
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#E8E8E9'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#969696'
            }
          }
        },
        series: [
          {
            name: '平均车价',
            type: 'line',
            zlevel: 2,
            // barWidth: '10%',
            barGap: '100%',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(85,168,253,0.2)'
              }, {
                offset: 1,
                color: 'rgba(85,168,253,0)'
              }])
            },
            data: this.averageAmount
          }
        ]
      }
      myChart.setOption(options, true)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-echarts-freight-line/index.vue"
}
</vue-filename-injector>
